module.exports = __webpack_public_path__ + "media/images/icons/min-circle-99c27989560efba0146381e4d5661a8e.svg";